import { Contact } from '../../../components/address-book';
import { Address, AddressTypeCode } from '../../../global-types/addresses';

export const mapContactToAddress = (contact: Contact): Address => {
  return {
    address_type_code: contact.contact_type_code as AddressTypeCode,
    first_name: contact.first_name,
    last_name: contact.last_name,
    display_name: contact.display_name,
    address_line_1: contact.address_line_1,
    address_line_2: contact.address_line_2,
    company_name: contact.company_name,
    city: contact.city,
    state_code: contact.state_code,
    zip: contact.zip,
    country_code: contact.country_code,
    skip_usps_validation: true,
  };
};
